module.exports = __webpack_public_path__ + "static/media/Group 1233.489e2543.svg";